import AppUsersClient from "../clients/AppUsersClient";
import moment from 'moment';
const resource = '/groupcomment';

export default {
  getOne(id) {
    return AppUsersClient.get(`${resource}/${id}`);
  },
  get(fromDate, toDate, forGroup) {
    return AppUsersClient.get(`${resource}`, { 
      params: { 
        fromDate: moment(fromDate).format('YYYY-MM-DD'),
        toDate: moment(toDate).format('YYYY-MM-DD'),
        forGroup: forGroup ? forGroup : ''
      }
    });
  },
  getForDayAndGroup(forDate, forGroup) {
    return AppUsersClient.get(`${resource}/${moment(forDate).format('YYYY-MM-DD')}/${forGroup ? forGroup : ''}`);
  },
  createOrUpdate(groupCommentForm) {
    return AppUsersClient.post(`${resource}`, groupCommentForm);
  },
  getGroupCommentsDashboard(fromDate, toDate) {
    return AppUsersClient.get(`${resource}/getDashboard/`, { 
      params: { 
        fromDate: moment(fromDate).format('YYYY-MM-DD'),
        toDate: moment(toDate).format('YYYY-MM-DD')
      }
    });
  },
};
